/* eslint-disable @typescript-eslint/no-empty-object-type */
 

export interface IUserPrefsState {
}

export const initialState: IUserPrefsState = {
};
